(ns ui.components.drop-tray.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/DropTray/styles.json
;; Source commit: b30917d39c4b174ae22a41570305a45d3acf8ed2
;; ----------------------------------------------------------------------------

(def drop-tray
  {:_meta
   {:tokens
    ["bg-drop-tray"
     "body-sm-font-size"
     "body-sm-font-weight"
     "body-sm-line-height"
     "border-drop-tray"
     "drop-tray-height"
     "drop-tray-target-height"
     "label-md-font-size"
     "label-md-font-weight"
     "label-md-line-height"
     "radius-drop-tray"
     "spacing-drop-tray-gap"
     "spacing-drop-tray-icon"
     "spacing-drop-tray-padding"
     "spacing-drop-tray-target-gap"
     "status-lost-badge-bg"
     "status-lost-badge-text"
     "status-lost-bar"
     "status-lost-surface"
     "status-on-hold-badge-bg"
     "status-on-hold-badge-text"
     "status-on-hold-bar"
     "status-on-hold-surface"
     "text-drop-tray"
     "text-secondary"],
    :generated-from "src/components/DropTray/DropTray.styles.ts"},
   :lost-icon
   {:base
    "tw2-size-drop-tray-icon tw2-shrink-0 tw2-text-status-lost-bar",
    :compound-variants [],
    :default-variants {}},
   :lost-label
   {:base "tw2-text-label-md",
    :active
    {:true "tw2-text-status-lost-badge-text",
     :false "tw2-text-secondary"},
    :compound-variants [],
    :default-variants {:active false}},
   :lost
   {:base
    "tw2-flex tw2-h-drop-tray-target-height tw2-w-full tw2-items-center tw2-justify-center tw2-gap-drop-tray-target-gap tw2-rounded-drop-tray tw2-border-dashed tw2-border-[length:var(--border-width-drop-tray)] tw2-border-status-lost-bar tw2-transition-transform tw2-duration-300 tw2-ease-out motion-reduce:tw2-transition-none",
    :state
    {:rest "tw2-bg-status-lost-surface",
     :active "tw2-scale-[1.02] tw2-bg-status-lost-badge-bg",
     :absorbing "tw2-scale-[1.05] tw2-bg-status-lost-badge-bg"},
    :compound-variants [],
    :default-variants {:state "rest"}},
   :on-hold
   {:base
    "tw2-flex tw2-h-drop-tray-target-height tw2-w-full tw2-items-center tw2-justify-center tw2-gap-drop-tray-target-gap tw2-rounded-drop-tray tw2-border-dashed tw2-border-[length:var(--border-width-drop-tray)] tw2-border-status-on-hold-bar tw2-transition-transform tw2-duration-300 tw2-ease-out motion-reduce:tw2-transition-none",
    :state
    {:rest "tw2-bg-status-on-hold-surface",
     :active "tw2-scale-[1.02] tw2-bg-status-on-hold-badge-bg",
     :absorbing "tw2-scale-[1.05] tw2-bg-status-on-hold-badge-bg"},
    :compound-variants [],
    :default-variants {:state "rest"}},
   :on-hold-icon
   {:base
    "tw2-size-drop-tray-icon tw2-shrink-0 tw2-text-status-on-hold-bar",
    :compound-variants [],
    :default-variants {}},
   :root
   {:base
    "tw2-flex tw2-h-drop-tray-height tw2-w-full tw2-flex-col tw2-items-start tw2-gap-drop-tray-gap tw2-border tw2-border-border-drop-tray tw2-bg-bg-drop-tray tw2-p-drop-tray-padding tw2-rounded-drop-tray tw2-shadow-lg",
    :compound-variants [],
    :default-variants {}},
   :on-hold-label
   {:base "tw2-text-label-md",
    :active
    {:true "tw2-text-status-on-hold-badge-text",
     :false "tw2-text-secondary"},
    :compound-variants [],
    :default-variants {:active false}},
   :message
   {:base "tw2-text-body-sm tw2-text-drop-tray",
    :compound-variants [],
    :default-variants {}}})
